import React from 'react';
import EVerifyUser from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUser';
import { columns } from '../../../../components/Enrollment/EVerifyUsers/data/EVerifyUsersTableData';
import AlertConstants from '../../../../constants/AlertConstants';
import HelpTextConstants from '../../../../constants/HelpTextConstants';
import BaseEVerifyUsers from './BaseEVerifyUsers';
import EnrollmentContent from '../../utils/EnrollmentContent';

const ChildEverifyUsers = (): JSX.Element => {
  const checkUsersForError = (users: EVerifyUser[]): AlertConstants | undefined => {
    const adminExists = users.some((user) => user.admin === 'Yes');
    const mouSignatoryExists = users.some((user) => user.mouSignatory === 'Yes');
    if (users?.length === 0 || (!adminExists && !mouSignatoryExists)) {
      return AlertConstants.EVERIFY_USERS_NO_USERS;
    }
    if (users.some((user) => user.mouSignatory === 'No' && user.admin === 'No')) {
      return AlertConstants.EVERIFY_USERS_NO_DESIGNATION_ERROR;
    }
    if (!adminExists && mouSignatoryExists) {
      return AlertConstants.EVERIFY_USERS_NO_PROGRAM_ADMIN;
    }
    if (adminExists && !mouSignatoryExists) {
      return AlertConstants.EVERIFY_USERS_NO_MOU_SIGNATORY_DESIGNATED;
    }
    return undefined;
  };

  return (
    <BaseEVerifyUsers
      addButtonText="Add User"
      noRowsText="No Users Added"
      primaryText={EnrollmentContent.everifyUsersPrimaryText}
      secondaryText={HelpTextConstants.EVERIFY_USERS_ENROLLMENT}
      columns={columns}
      checkUsersForError={checkUsersForError}
    />
  );
};

export default ChildEverifyUsers;
